// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignLeftOutlinedSvg
  }));
};

AlignLeftOutlined.displayName = 'AlignLeftOutlined';
export default React.forwardRef(AlignLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlignLeftOutlined.js
// module id = 539
// module chunks = 0